import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { LOCALE_ID } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { Router, NavigationEnd } from '@angular/router';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

// Core modules
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// Modular configuration files
import { CoreModule } from './modules-config/core.module';
import { SharedModule } from './modules-config/shared.module';
import { AppServiceWorkerModule } from './modules-config/service-worker.module';
import { StateModule } from './modules-config/state.module';
import { FeatureModules } from './modules-config/feature-modules';

// Providers and declarations
import { AppProviders } from './modules-config/app.providers';
import { AppDeclarations } from './modules-config/app.declarations';

// Interceptors
import { TokenInterceptor } from './apis/token.interceptor';
import { initLangage, TranslationModule } from './modules-config/translation.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from './utils/Service/CustomTranslateLoader';
import { ConnectionService } from './services/connection.service';
import { VersionCheckService } from './apis/version-check.service';
import { Store } from '@ngrx/store';
import { ConnectionState } from './utils/states-management/reducers/offline.reducer';
import { PhotoSourcePopoverComponent } from './components/photo-source-popover/photo-source-popover.component';

import Userback from "@userback/widget";
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    ...AppDeclarations,
    PhotoSourcePopoverComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,

    AppServiceWorkerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
      defaultLanguage: 'en'
    }),
    StateModule,
    ...FeatureModules,
    CommonModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    ...AppProviders,
    ConnectionService,
  ],
  exports: [
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  private isOnline = false;
  private userBackWidgetInstance: any = null;
  private lastConnectionState: 'good' | 'poor' | 'offline' = 'good';

  constructor(
    private router: Router,
    private store: Store<{ connection: ConnectionState }>,
  ) {
    this.store.select('connection').pipe(
      distinctUntilChanged((a, b) =>
        a.isOnline === b.isOnline &&
        a.connectionQuality === b.connectionQuality
      )
    ).subscribe(({ isOnline, connectionQuality }) => {
      if (isOnline) {
        Userback('34570|66635|bN7yiPocCv0hJFZ656a0asFlo', {}).then((userback) => {
          userback.open();
        });
      }
      this.isOnline = isOnline;
      this.lastConnectionState = connectionQuality;
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event.url.includes('/home') && this.lastConnectionState === 'poor') {
        // Handle poor connection scenario
      }
    });
  }
}